const ID = ':id';

export const REQUEST_P = 'requests';
export const REQUEST_PF = `/${REQUEST_P}`

export const SHIPMENT_P = 'shipment';
export const SHIPMENT_PF = `${REQUEST_PF}/${SHIPMENT_P}`;
export const SEND_SHIPMENT_P = `send-${SHIPMENT_P}`;
export const SEND_SHIPMENT_PF = `${REQUEST_PF}/${SEND_SHIPMENT_P}`;
export const SHIPMENT_ID_P = `${SHIPMENT_P}-detail/${ID}`;
export const SHIPMENT_ID_PF = `${REQUEST_PF}/${SHIPMENT_ID_P}`;

export const ISO_TANK_P = 'iso-tank';
export const ISO_TANK_PF = `${REQUEST_PF}/${ISO_TANK_P}`;
export const SEND_ISO_TANK_P = `send-${ISO_TANK_P}`;
export const SEND_ISO_TANK_PF = `${REQUEST_PF}/${SEND_ISO_TANK_P}`;
export const ISO_TANK_ID_P = `${ISO_TANK_P}-detail/${ID}`;
export const ISO_TANK_ID_PF = `${REQUEST_PF}/${ISO_TANK_ID_P}`;

export const DEPOT_P = 'depot';
export const DEPOT_PF = `${REQUEST_PF}/${DEPOT_P}`;
export const SEND_DEPOT_P = `send-${DEPOT_P}`;
export const SEND_DEPOT_PF = `${REQUEST_PF}/${SEND_DEPOT_P}`;
export const DEPOT_ID_P = `${DEPOT_P}-detail/${ID}`;
export const DEPOT_ID_PF = `${REQUEST_PF}/${DEPOT_ID_P}`;

export const TRANSPORT_P = 'transport';
export const TRANSPORT_PF = `${REQUEST_PF}/${TRANSPORT_P}`;
export const SEND_TRANSPORT_P = `send-${TRANSPORT_P}`;
export const SEND_TRANSPORT_PF = `${REQUEST_PF}/${SEND_TRANSPORT_P}`;
export const TRANSPORT_ID_P = `${TRANSPORT_P}-detail/${ID}`;
export const TRANSPORT_ID_PF = `${REQUEST_PF}/${TRANSPORT_ID_P}`;